module.exports = __webpack_public_path__ + "static/media/3numeral2.26dfbe35.jpg";